import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import shouldPureComponentUpdate from 'react-pure-render/function';
import './BookSupplierPrincipals.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  bookState: state.bookState,
});

export class BookSupplierPrincipals extends Component {
  static propTypes = {
    bookState: PropTypes.object.isRequired,
  };

  state = {
    showContent: {},
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  toggleContent = (event) => {
    event.preventDefault();
    const index = event.currentTarget.dataset.index;
    const isVisible = !!this.state.showContent[index];
    this.setState({
      showContent: {
        [`${index}`]: !isVisible,
      },
    });
  };

  get suppliers() {
    return this.props.bookState.getIn(['data', 'ETC']);
  }

  getContent = index => (
    { __html: this.props.bookState.getIn(['data', 'ETC', `${index}`, 'content']) }
  )

  render() {
    const suppliers = this.suppliers;

    return (
      <div className="book-supplier-principals">
        <p>For all arrangements, your contract will be with the Supplier Principal(s) relevant to your booking. Their Terms and Conditions are detailed below:</p>
        {
          suppliers && suppliers.size > 0 && suppliers.map((supplier, index) => {
            const supplierName = supplier.get('supplierName');
            const url = supplier.get('url');
            const supplierLegalName = supplier.getIn(['supplierLegalName', 'principalName']);

            return url ? (
              <p key={index}>
                <a className="book-supplier-principals__external-link" href={url} target="_blank">
                  {supplierName}
                </a>
              </p>
            ) : (
              <div key={index}>
                <a href="#" className="book-supplier-principals__extendable-link" onClick={this.toggleContent} target="_blank" data-index={index}>
                  {`${supplierLegalName} Terms & Conditions`}
                </a>
                {
                  this.state.showContent[index] && (
                    <div className="book-supplier-principals__content" dangerouslySetInnerHTML={this.getContent(index)} />
                  )
                }
              </div>
            );
          })
        }
      </div>
    );
  }
}

export default connect(mapStateToProps)(BookSupplierPrincipals);



/** WEBPACK FOOTER **
 ** ./src/components/BookSupplierPrincipals/BookSupplierPrincipals.jsx
 **/